import { useComponentI18n } from "./useComponentI18n"
import I18nAgeRestrictions from "../components/I18nAgeRestrictions.vue"

interface AgeLimitOptions {
  min: number | null
  max: number | null
}

export function useGetAgeLimitString() {

  const t = useComponentI18n(I18nAgeRestrictions)

  const getAgeLimitString = ({ min, max }: AgeLimitOptions) => {
    return computed(() => {
      if (!max)
        return `${t('Ages')} ${min}+`
      if (min === max)
        return `${t('Age')} ${min}`
      else
        return `${t('Ages')} ${min} - ${max}`
    })
  }

  const getAgeLimitFilterString = ({ min, max }: AgeLimitOptions) => {
    return computed(() => {
      if (max && min)
        return max === min ? `${min}` : `${min} - ${max}`
      if (max)
        return `${t('under')} ${max}`
      if (min)
        return `${t('over')} ${min}`
      return ''
    })
  }

  return { 
    getAgeLimitString,
    getAgeLimitFilterString,
  }
}